import styled from '@emotion/styled';

export const BrandedTourHeader = styled.div<{ backgroundColor?: string }>`
  align-items: center;
  background-color: ${(props) => props.backgroundColor || '#1a1a1a'};
  color: #fff;
  display: flex;
  font-size: 28px;
  font-family: inherit;
  font-weight: 400;
  gap: 15px;
  height: 80px;
  justify-content: center;
`;

export const BrandedHeaderLink = styled.a`
  align-items: center;
  color: #fff;
  display: flex;
  gap: 15px;

  &:hover {
    color: #fff;
  }
`;

export const BrandedHeaderLogo = styled.img`
  max-height: 60px;
  max-width: 100%;
`;

export const RoundUserLogo = styled.div`
  border: 1px solid #323232;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
  height: 50px;
  overflow: hidden;
  width: 50px;
`;

export const RoundUserLogoImage = styled.img`
  height: 100%;
  object-fit: cover;
  width: 100%;
`;
